<template>
  <el-row class="mr-b20" slot="content" >
    <div class="mr-b4" align="right">
      <el-button type="primary" size="mini" :disabled="!cellEditing.isModified" @click="saveMaintenanceHist">저장</el-button>
      <el-button size="mini" @click="cancel">취소</el-button>
    </div>
    <el-table-wrapper height="750px" v-loading="isLoading" ref="histTable" :data="maintenanceHistData" :columns="columns" style="width:100%;" :pagination="true" :editable="true"
      :total="total" :column-default="columnDefault" @condition-change="onTableConditionChange" @cell-dblclick="startEdit">
      <template slot-scope="scope" slot="input-slot">
        <w-input-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property" :required="true" @cell-edit-end="endEdit" />
      </template>
      <template slot-scope="scope" slot="normalFlag">
        <w-checkbox-editor :editing-prop="cellEditing.property" :data="scope.row" :property="scope.column.property"
          v-if="scope.row.rsctypeId === 'NI_RUNNINGSTATUS'"  true-label="1" false-label="0" @cell-edit-end="editTwoStatusCell" />
      </template>
    </el-table-wrapper>
  </el-row>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import reportApi from '@/api/report/report';
import CellEditingMixin from '@/mixins/table/cell-editing';
import msgUtil from '@/utils/message';
import WInputEditor from '@/components/table/cell-editor/InputEditor';
import WCheckboxEditor from '@/components/table/cell-editor/CheckboxEditor';
import { columnDefault } from '@/constants/table';
import { getDateToString } from '@/utils/date';

export default {
  name: 'WMaintenanceHistDetailView',
  mixins: [CellEditingMixin],
  components: {
    WInputEditor,
    WCheckboxEditor,
  },
  props: {
    popupParams: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      columnDefault,
      maintenanceHistData: [],
      maintenanceHistDataOrg: [],
      total: null,
      isLoading: false,
      columns: [
        { type: 'index', label: 'No.', width: '50px' },
        { prop: 'customerName', label: '고객사', width: '100px', remoteProp: 'customer_name' },
        { prop: 'serviceName', label: '서비스', width: '100px', remoteProp: 'service_name' },
        { prop: 'rscName', label: '점검 항목', width: '150px', remoteProp: 'rsc_name' },
        { prop: 'objName', label: 'Hostname', remoteProp: 'obj_name' },
        { prop: 'modelName', label: '장비 모델', width: '150px', remoteProp: 'model_name' },
        { prop: 'netinterfaceName', label: '인터페이스명', width: '150px', remoteProp: 'netinterface_name' },
        { prop: 'remark', label: '특이사항', width: '150px', remoteProp: 'remark' },
        { prop: 'actionPlan', label: '조치 계획', width: '100px', editable: true, remoteProp: 'action_plan', scopedSlot: 'input-slot' },
        { prop: 'actionType', label: '조치 구분', width: '100px', editable: true, remoteProp: 'action_type', scopedSlot: 'input-slot' },
        { prop: 'manager', label: '점검자', width: '100px', remoteProp: 'manager' },
        { prop: 'normalFlag', label: '정상 여부', width: '80px', align: 'center', editable: true, filterMultiple: false, remoteProp: 'normal_flag', scopedSlot: 'normalFlag' },
      ],
    };
  },
  methods: {
    loadData() {
      const params = {
        reportId: this.popupParams.reportId,
        generateDate: this.popupParams.generateDate,
      };

      if (this.isLoading === false) {
        this.isLoading = true;
      }

      reportApi.getMaintenanceHist(params).then((response) => {
        if (response.data.success) {
          const data = cloneDeep(response.data.data);
          this.maintenanceHistData = this.getEditableTableData(data, this.columns);
          this.maintenanceHistDataOrg = cloneDeep(this.maintenanceHistData);
          this.resetCellEditing();
        }
        this.isLoading = false;
      });
    },
    saveMaintenanceHist() {
      const updatedData = this.getUpdatedDatas(this.maintenanceHistData, true, ['reportId', 'customerId', 'serviceId', 'objId', 'rsctypeId', 'rscId', 'rscName', 'remark', 'actionPlan', 'actionType', 'manager', 'normalFlag', 'checkDatetime']);
      reportApi.updateMaintenanceHist(updatedData).then((response) => {
        if (response.data.success) {
          this.loadData();
        }
        this.isSaveFlag = false;
        this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '점검 이력', response.data.success));
      }).catch(() => {
        this.isSaveFlag = false;
        this.$message(msgUtil.getResultMsgData(msgUtil.action.MODIFY, '점검 이력', false));
      });
    },
    cancel() {
      this.maintenanceHistData = cloneDeep(this.maintenanceHistDataOrg);
    },
    convertDatetime(row, column, value) {
      return getDateToString(value);
    },
    onTableConditionChange() {
      this.loadData();
    },
    /**
     * 셀 편집 후처리
     * @author Ju
     * @param  {[type]} data     [description]
     * @param  {[type]} property [description]
     * @param  {[type]} dirty    [description]
     */
    handlerEndEdit(data, property, dirty) {
      if (dirty) {
        if (property === 'objCompanyId') {
          // objCompanyId 수정 시 objProductId 값 null 설정.
          this.editDirect(data, 'objProductId', null);
        }
      }
      this.checkExistModifiedData(this.maintenanceHistData);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/report/popup/components/MaintenanceHistDetailView.vue